import React, { useState, useRef, useEffect } from "react";
import { FacturaPago } from "./modalFacturaPago";
import { OtrosImpuestos } from "./modalOtroPago";
import axios from "axios";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import moment from "moment";
import { FacturaMultaPago } from "./modalFactMultaPago";
import { TasasPagos } from "./modalFacturaTasasPagos";
import { FacturaPublicidadPago } from "./modalFacturaPublicidadPago";
import { formatMoneda } from "../../../util/varios";
import PagosRegistros2 from "./registrarpagos2";

function CajaIngresos2() {
  const [impresora, setImpresora] = useState(null);

  useEffect(() => {
    const impresoraStorage = localStorage.getItem("impresora");

    if (impresoraStorage) setImpresora(JSON.parse(impresora));
  }, []);


  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [impresor, setImpresor] = useState(false);
  const [factorCambio, setFactorCambio] = useState(0);
  const [idtipoimpuesto, setIdtipoimpuesto] = useState(null);
  const [idtipoimpuestos, setIdtipoimpuestos] = useState(null);
  const [tipoImpuesto, setTipoImpuesto] = useState(null);
  const [valor, setValor] = useState(null);
  const [numCaja, setNumCaja] = useState(
    JSON.parse(localStorage.getItem("numcaja"))
  );
  const [facturas, setFacturas] = useState([]);
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const radioFactu = useRef();
  const radioVerifi = useRef();
  const [mostrarFacturaMulta, setMostrarFacturaMulta] = useState(false);
  const [mostarTasasP, setMostrarTasasP] = useState(false);
  const [mostrarPublicidad, setMostrarPublicidad] = useState(false);

  var op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  useEffect(() => {
    validarPrint();
    let obj = JSON.parse(localStorage.getItem("post"));
    setNumCaja(obj.numCaja);
    radioFactu.current.checked = true;
    radioVerifi.current.checked = false;
    seleccionarFacturas();
    seleccionarFactorCambio();
  }, []);

  const cargarpago = (tipoimpu, tipo) => (e) => {
    e.preventDefault();
    if (numCaja === "" || numCaja === null) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuesto(tipo);
    setTipoImpuesto(tipoimpu);
    setValor(valor);
    setMostrar(true);
  };

  const seleccionarFactorCambio = () => {
    let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);
          setFactorCambio(response.data.valor);
        }
      })
      .catch(function (error) {
        setActivate(false);
      });
  };

  const cargarotropago = (tipo) => (e) => {
    e.preventDefault();
    if (numCaja === "" || numCaja === null) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuestos(tipo);
    setMostrar2(true);
  };

  const cargaroFacturaMulta = (tipo) => (e) => {
    e.preventDefault();
    if (numCaja === "" || numCaja === null) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuestos(tipo);
    setMostrarFacturaMulta(true);
  };

  const cargaroTasasPago = (tipo) => (e) => {
    e.preventDefault();
    if (numCaja === "" || numCaja === null) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuestos(tipo);
    setMostrarTasasP(true);
  };

  const cargarPubicidadLicores = (tipoimpu, tipo) => (e) => {
    e.preventDefault();
    if (numCaja === "" || numCaja === null) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuesto(tipo);
    setTipoImpuesto(tipoimpu);
    setMostrarPublicidad(true);
  };

  const seleccionarFacturas = () => {
    let campos = "*";
    let nomtab = "factura";
    let fe = "'" + moment.utc(fechaSistema).format("YYYY-MM-DD") + "'";
    let sta = 0;
    let condi = "";
    if (radioFactu.current.checked) {
      condi = `facturador = ${idusuario} AND fechaemision = ${fe} AND status = ${sta}`;
    } else {
      let letra = "'V'";
      condi = ` substring(numfactura, 1, 1) = ${letra} AND status = ${sta}`;
    }

    let orden = "1";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let fact = [];
          for (let i = 0; i < response.data.length; i++) {
            fact.push({
              idfactura: response.data[i].idfactura,
              numfactura: response.data[i].numfactura,
              idcontribuyente: response.data[i].idcontribuyente,
              totalinmpuesto: response.data[i].totalinmpuesto,
              totalrecargo: response.data[i].totalrecargo,
              totalinteres: response.data[i].totalinteres,
              idtipoingreso: response.data[i].idtipoingreso,
              fechaemision: response.data[i].fechaemision,
              descripcion: response.data[i].descripcion,
              tablacontribuyente: response.data[i].tablacontribuyente,
              tabladeuda: response.data[i].tabladeuda,
              iddeuda: response.data[i].iddeuda,
              status: response.data[i].status,
              nombrecontri: response.data[i].nombrecontri,
              direccioncontri: response.data[i].direccioncontri,
              cedrif: response.data[i].cedrif,
              totalmulta:
                response.data[i].totalmulta === null
                  ? "0.00"
                  : response.data[i].totalmulta,
              deducible: response.data[i].deducible,
              facturador: response.data[i].facturador,
              totalfactura:
                parseFloat(response.data[i].totalinmpuesto) +
                parseFloat(response.data[i].totalrecargo) +
                parseFloat(response.data[i].totalinteres) +
                parseFloat(
                  response.data[i].totalmulta === null
                    ? "0.00"
                    : response.data[i].totalmulta
                ) -
                parseFloat(response.data[i].deducible),
              idcomercio: response.data[i].idcomercio,
              tipodeuda: response.data[i].tipodeuda,
            });
          }
          setFacturas(fact);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const handleAceptaFactura = () => {
    setMostrar(false);
    seleccionarFacturas();
  };

  const handleAceptaFacturaPublicidad = () => {
    setMostrarPublicidad(false);
    seleccionarFacturas();
  };

  const handleAceptaFacturaMulta = () => {
    setMostrarFacturaMulta(false);
    seleccionarFacturas();
  };

  const handleAceptaFacturaTasa = () => {
    setMostrarTasasP(false);
    radioFactu.current.checked = true;
    radioVerifi.current.checked = false;
    seleccionarFacturas();
  };

  const handleAceptaOtroPago = () => {
    setMostrar2(false);
    seleccionarFacturas();
  };

  const handleChangeRadio = (event) => {
    if (event.target.name === "radioTipo") {
      if (radioFactu.current.checked) {
      } else if (radioVerifi.current.checked) {
      }
    }

    seleccionarFacturas();
  };

  const validarPrint = () => {
    if (impresora) {
      let endpoint = `http://${impresora}:9000/validar`;

      axios.get(endpoint).then(function (response) {
        if (response.status === 200) {
          setImpresor(true);
        } else {
          setImpresor(false);
        }
      });
    } else {
      setImpresor(false);
    }
  };

  return (
    <div style={{ height: "94dvh" }} className="col-12 m-0 p-0">
      <div className="h-100 w-100 col-12 m-0 p-0 d-flex flex-wrap align-items-center">
        <div className="h-100 row container-fluid m-0 p-0">
          <nav className="h-100 col-4 col-md-3 col-lg-2 m-0 p-4 
            d-flex flex-column justify-content-center gap-4 bg-secondary">
            <a
              onClick={cargarpago("Actividad Económica", 0)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-industry me-2"></i>
              <span className="">Actividades Economicas</span>
            </a>
            <a
              onClick={cargarpago("Inmuebles Urbanos", 1)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-home me-2" />
              <span className="">Inmuebles Urbanos</span>
            </a>
            <a
              onClick={cargarpago("Patente de Vehiculo", 2)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-car me-2" />
              <span className="">Patente de Vehiculos</span>
            </a>
            <a
              onClick={cargarPubicidadLicores("Publicidad", 0, true)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-chalkboard-teacher me-2" />
              <span className="">Publicidad</span>
            </a>
            <a
              onClick={cargarPubicidadLicores("Licores", 1)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-industry me-2" />
              <span className="">Licores</span>
            </a>
            <a
              onClick={cargarpago("Aseo Urbano", 4)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-hard-hat me-2" />
              <span className="">Aseo Urbano</span>
            </a>
            <a
              onClick={cargarpago("Alquiler de Edificios Y Locales", 6)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-hard-hat me-2" />
              <span className="">Alquiler de Edificios Y Locales</span>
            </a>
            <a
              onClick={cargarpago("Mercado Municipal", 5)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-hard-hat me-2" />
              <span className="">Mercado Municipal</span>
            </a>
            <a
              onClick={cargarpago("Ejidos", 7)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-hard-hat me-2" />
              <span className="">Ejidos</span>
            </a>
            <a
              onClick={cargarpago("Economía Informal", 8)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-hard-hat me-2" />
              <span className="">Economía Informal</span>
            </a>
            <a
              onClick={cargarotropago(
                "Impresión de Factura - Otros Impuestos",
                true
              )}
              className="text-light"
              type="button"
            >
              <i className="fas fa-piggy-bank me-2" />
              <span className="">Otros Impuestos</span>
            </a>
            <a
              onClick={cargaroFacturaMulta("produccion", "produccion", true)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-hard-hat me-2" />
              <span className="">Multas</span>
            </a>
            <a
              onClick={cargarpago("produccion", "produccion", true)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-hard-hat me-2" />
              <span className="">Ingresar Factura</span>
            </a>
            <a
              onClick={cargaroTasasPago("tasas", "tasas", true)}
              className="text-light"
              type="button"
            >
              <i className="fas fa-hard-hat me-2" />
              <span className="">Tasas</span>
            </a>
          </nav>
          {/* CONTENT */}
          <div className="col-8 col-md-9 col-lg-10 m-0 px-5 align-content-center justify-content-center">
            <div className="col-12 m-0 p-0 shadow rounded">
              <header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant rounded-top">
                <h3 className="fs-4 m-0 fw-bold text-light">
                  Facturación Integral
                </h3>
                <a type="button" className="text-light fw-bold">
                  Salir
                  <i className="fas fa-times ms-2"></i>
                </a>
              </header>
              <div className="col-12 m-0 p-2 d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center p-0 gap-2">
                  <input
                    className=""
                    type="radio"
                    ref={radioFactu}
                    name="radioTipo"
                    id="radioFactura"
                    onChange={handleChangeRadio}
                  />
                  <label className="m-0" htmlFor="radioFactura">
                    Procesar Facturas
                  </label>
                </div>
                <div className="d-flex align-items-center p-0 gap-2">
                  <input
                    className=""
                    type="radio"
                    ref={radioVerifi}
                    name="radioTipo"
                    id="radioVerifica"
                    onChange={handleChangeRadio}
                  />
                  <label className="m-0" htmlFor="radioVerifica">
                    Procesar Verificaciones
                  </label>
                </div>

                <i
                  className={
                    impresor
                      ? "fa fa-print text-success"
                      : "fa fa-print text-danger"
                  }
                >
                </i>
                <span className="fw-bold border rounded p-2">
                  Valor Euro:
                  <span className="fs-5">
                    {" €" +
                      formatMoneda(
                        factorCambio
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                  </span>
                </span>
              </div>
              <PagosRegistros2
                factorCambio={factorCambio}
                facturas={facturas}
                onHideRenderizar={seleccionarFacturas}
                tipo={radioFactu.current && radioFactu.current.checked ? 1 : 2}
              />
            </div>
          </div>
        </div>
      </div>
      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <FacturaPago
        show={mostrar}
        factorCambio={factorCambio}
        tipo={idtipoimpuesto}
        tipoImpuesto={tipoImpuesto}
        valor={valor}
        onHideCancela={() => setMostrar(false)}
        onHideAcepta={handleAceptaFactura}
      />

      <FacturaMultaPago
        show={mostrarFacturaMulta}
        onHideCancela={() => setMostrarFacturaMulta(false)}
        onHideAcepta={handleAceptaFacturaMulta}
      />

      <TasasPagos
        show={mostarTasasP}
        tipo={0}
        onHideCancela={() => { setMostrarTasasP(false); radioFactu.current.checked = true; radioVerifi.current.checked = false; }}
        onHideAcepta={handleAceptaFacturaTasa}
        factorCambio={factorCambio}
      />

      <FacturaPublicidadPago
        tipo={idtipoimpuesto}
        tipoImpuesto={tipoImpuesto}
        valor={valor}
        show={mostrarPublicidad}
        onHideCancela={() => setMostrarPublicidad(false)}
        onHideAcepta={handleAceptaFacturaPublicidad}
        factorCambio={factorCambio}
      />

      <OtrosImpuestos
        show={mostrar2}
        tipo={idtipoimpuestos}
        onHideCancelar={handleAceptaOtroPago}
      />
    </div>
  );
}

export default CajaIngresos2;
